import { ActionType } from 'typesafe-actions';

import { IPlanState } from '../interfaces/IPlanState';
import * as actions from '../actions/planActions';
import { PlanActionsEnum } from '../enums/PlanActionsEnum';

export type PlanAction = ActionType<typeof actions>;

const initial: IPlanState = {
  isLoadingDocuments: false,
  isLoadingHistory: false,
  initialFormValues: {
    signerFullName: undefined,
    signerPosition: undefined,
  },
};

export function planReducer(state = initial, action: PlanAction) {
  switch (action.type) {
    case PlanActionsEnum.PLAN_SET_PLAN: {
      const newState: IPlanState = {
        ...state,
        data: {
          ...state.data,
          ...action.payload.plan,
        },
      };

      return newState;
    }
    case PlanActionsEnum.PLAN_SET_INFO: {
      const newState: IPlanState = {
        ...state,
        planInfo: action.payload.planInfo,
      };

      return newState;
    }
    case PlanActionsEnum.PLAN_SET_SUPERVISION_TYPE_VALUE: {
      const newState: IPlanState = {
        ...state,
        supervisionTypeValue: action.payload.supervisionTypeValue,
      };

      return newState;
    }
    case PlanActionsEnum.PLAN_SET_LOADING_DOCUMENTS: {
      const newState: IPlanState = {
        ...state,
        isLoadingDocuments: action.payload.value,
      };

      return newState;
    }
    case PlanActionsEnum.PLAN_SET_LOADING_HISTORY: {
      const newState: IPlanState = {
        ...state,
        isLoadingHistory: action.payload.value,
      };

      return newState;
    }
    case PlanActionsEnum.PLAN_SET_PLAN_DOCUMENTS: {
      const newState: IPlanState = {
        ...state,
        planDocuments: action.payload.documents,
      };

      return newState;
    }
    case PlanActionsEnum.PLAN_SET_PLAN_HISTORY: {
      const newState: IPlanState = {
        ...state,
        history: action.payload.history,
      };

      return newState;
    }
    case PlanActionsEnum.PLAN_SET_PLAN_HISTORY_CHANGES: {
      const newState: IPlanState = {
        ...state,
        historyChanges: action.payload.historyChanges,
      };

      return newState;
    }
    case PlanActionsEnum.PLAN_SET_IS_PRIVILEGES_KNO: {
      const newState: IPlanState = {
        ...state,
        isPrivilegesKno: action.payload.isPrivilegesKno,
      };

      return newState;
    }
    case PlanActionsEnum.PLAN_SET_FORM_REF: {
      return {
        ...state,
        formRef: action.payload.formRef,
      };
    }
    case PlanActionsEnum.PLAN_SET_INITIAL_FORM_VALUES: {
      const { initialFormValues } = action.payload;

      return {
        ...state,
        initialFormValues: {
          ...state.initialFormValues,
          ...initialFormValues,
        },
      };
    }
    default:
      return state;
  }
}
